import React, { useState, useEffect } from "react";
import { TopBar } from "../../shared/topBar/TopBar";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { sbaAxios } from "../../utils/sbaAxios";
import {
  getActiveusers,
  getUserPageTracking,
  getUsersLogin,
  sendAdminNotifcation,
  sendNotificationToUser,
  getUsers
} from "../../../config/apiConfig";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer, toast } from "react-toastify";
import { useMsal } from "@azure/msal-react";
import { SBAComboBox, SBAMultiSelect } from "../../UiComponents/SBADropDown";

const NotificationConsole = () => {
  const { instance, accounts } = useMsal();
  const [notification, setNotification] = useState({
    userId: 0,
    userName: accounts[0]?.name | "NAN",
    header: "AES Notification",
    message: "This is Test Notification message please ignore ",
  });
  const [selectedUsers, setSelectedUser] = useState([]);
  const [activeUsers, setActiveUsers] = useState([]);
  useEffect(() => {
    document.title = "Notification";
    getActiveUsers(false);
  }, []);
  const getActiveUsers = async (fromButtonClick) => {
    try {
      const [activeUsers] = await Promise.all([
        sbaAxios({ url: getActiveusers }),
      ]);
      setActiveUsers(activeUsers);
      if(fromButtonClick)
      {toast.success("List refreshed")}
    } catch (error) {
      console.error("Error fetching active users:", error);
      setActiveUsers([]);
    }
  };

  const handleSend = async () => {
    try {
      if (!notification.header.trim()) {
        SBNotify({ Msg: "Header can't be Empty", type: "error" });
        return;
      }
      if (!notification.message.trim()) {
        SBNotify({ Msg: "Message can't be Empty", type: "error" });
        return;
      }
      const results = await sbaAxios({
            url: sendAdminNotifcation,
            method: "post",
            data: {...notification, userName: accounts[0]?.name },
          });
       SBNotify({ Msg: "Notification Sent Successfully", type: "success" });
    } catch (error) {
      SBNotify({ Msg: "Error Occured", type: "error" });
    }
  };
  const sendToUser = async () => {
    try {
      if (!notification.header.trim()) {
        SBNotify({ Msg: "Header can't be Empty", type: "error" });
        return;
      }
      if (!notification.message.trim()) {
        SBNotify({ Msg: "Message can't be Empty", type: "error" });
        return;
      }
      const results = await Promise.all(
        selectedUsers.map((user) =>
          sbaAxios({
            url: sendNotificationToUser,
            params: { toUserId: user.userId},
            method: "post",
            data: { 
               "notificationId": 0,
               "notificationRefNumber": new Date().getTime(),
               "header": notification.header,
               "message": notification.message,
               "sentBy": 0,
               "sentTo": user.userId,
               "sentTime": new Date().toISOString(),
               "isRead": false,
               "readTime": new Date().toISOString(),
               "userName": accounts[0]?.name,
               "connectionIds":user.connectionIds
              },
               
          })
        )
      );
      const allSuccess = results.every((res) => res.success);
      if (allSuccess) {
        SBNotify({ Msg: "Notification Sent Successfully", type: "success" });
      } else {
        SBNotify({ Msg: "Error Occurred in some requests", type: "error" });
      }
    } catch (error) {
      SBNotify({ Msg: "Error Occured", type: "error" });
    }
  };
  const Level = [
    { BreadCrumb: "Admin > ", Routes: `${UrlPath.Admin}` },
    { BreadCrumb: "Notification", Routes: `${UrlPath.AdminNotification}` },
  ];
  const CustomItemRender = (li, itemProps) => {
    const { dataItem } = itemProps;
    const isOnline = dataItem.isOnline;
    const color = isOnline ? "green" : "red";
  
    return React.cloneElement(li, {}, (
      <span style={{ color }}>
        {dataItem.displayName}
      </span>
    ));
  };

  return (
    <>
      <TopBar label={"Notification"} />
      <div className="mainContentData">
        <BreadCrumbs Levels={Level} />
        <div className="container-fluid">
          <div className="col-6">
            <h4>Send Notification</h4>

            {/* <label className="my-2 label">Active Users</label>
                        <SBAMultiSelect data={activeUsers}
                        value={selectedUsers}
                         onChange={(e)=>{if(e.value){
                            setSelectedUser(e.value);
                         }}}
                         tags={selectedUsers.length> 0 ? [{ text: `${selectedUsers.length} items selected`, data: [...selectedUsers] }] : []}

                         textField="userName"
                         dataItemKey="connectionId"
                            /> */}
            <label className="my-2 label">Active Users</label>
            <div className="flex items-center gap-2">
              <SBAMultiSelect
                data={activeUsers}
                value={selectedUsers}
                onChange={(e) => {
                  if (e.value) {
                    setSelectedUser(e.value);
                  }
                }}
                tags={
                  selectedUsers.length > 0
                    ? [
                        {
                          text: `${selectedUsers.length} items selected`,
                          data: [...selectedUsers],
                        },
                      ]
                    : []
                }
                textField="displayName"
                dataItemKey="userId"
                itemRender={CustomItemRender}
              />
              <button
                className="p-sm-btn my-3"
                onClick={()=>{getActiveUsers(true)}}
                title="Refresh Active Users"
              >
                Refresh List
              </button>
            </div>

            <label className="my-2 label">Header</label>
            <input
              type="text"
              placeholder="Type your Header"
              className="form-control my-2"
              onChange={(e) =>
                setNotification((val) => ({ ...val, header: e.target.value }))
              }
              value={notification.header}
            />
            <label className="my-2 label">Message</label>
            <textarea
              type="text"
              placeholder="Type your message"
              className="form-control my-2"
              value={notification.message}
              onChange={(e) =>
                setNotification((val) => ({ ...val, message: e.target.value }))
              }
            />
            <button
              className="p-sm-btn my-3"
              onClick={() => {
                handleSend();
              }}
            >
              Send To All
            </button>
            <button
              className="p-sm-btn my-3 mx-3"
              onClick={() => {
                sendToUser();
              }}
              disabled={selectedUsers.length === 0}
            >
              Send To Selected User
            </button>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default NotificationConsole;
